export class User {

    constructor(){
        this.groups = {};
    }
    
    username: string;
    password: string;
    access_token: string;
    refresh_token: string;
    laboratoryId: number;
    wards: string;
    authorities: string[];
    groups: any;
    systemProperties: any;

    report: number;
    'order-entry': number;
    phlebotomy: number;
    configuration: number;

    getSystemProperty(prop){
        return this.systemProperties.filter(elem => elem.parameterId ==prop)[0].parameterValue
    }
}
